<article
  class="model-card"
  role="button"
  tabindex="0"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="$event.preventDefault(); onCardClick()"
>
  <div class="model-card__header-row min-w-0">
    <h3 class="model-card__title leading-snug m-0 min-w-0">
      {{ card.title }}
    </h3>
  </div>

  <div class="model-card__content flex flex-col gap-4 min-w-0">
    <div class="model-card__description-slot">
      @if (card.shortDescription) {
        <p class="model-card__description text-sm leading-relaxed m-0">
          {{ card.shortDescription }}
        </p>
      }
    </div>

    <div class="flex flex-wrap gap-2">
      @for (tag of card.tags; track tag) {
        <span class="model-card__tag">{{ tag }}</span>
      }
    </div>

    <div class="model-card__info-grid">
      @if (card.organization) {
        <span class="model-card__info-line inline-flex items-center gap-2 min-w-0 text-sm">
          <img src="/icons/org-grey.svg" alt="" class="model-card__meta-icon shrink-0" width="14" height="14" />
          <span class="truncate">{{ card.organization }}</span>
        </span>
      }
      @if (card.industry) {
        <span class="model-card__info-line inline-flex items-center gap-2 min-w-0 text-sm">
          <img src="/icons/person.svg" alt="" class="model-card__meta-icon shrink-0" width="14" height="14" />
          <span class="truncate">{{ card.industry }}</span>
        </span>
      }
      @if (card.modelType) {
        <span class="model-card__info-line inline-flex items-center gap-2 min-w-0 text-sm">
          <img src="/icons/models-grey.svg" alt="" class="model-card__meta-icon shrink-0" width="14" height="14" />
          <span class="truncate">{{ card.modelType }}</span>
        </span>
      }
      @if (card.language) {
        <span class="model-card__info-line inline-flex items-center gap-2 min-w-0 text-sm">
          <img src="/icons/file-grey.svg" alt="" class="model-card__meta-icon shrink-0" width="14" height="14" />
          <span class="truncate">{{ card.language }}</span>
        </span>
      }
      @if (card.date) {
        <div class="model-card__date-row inline-flex items-center gap-2 text-sm">
          <img src="/icons/timer-grey.svg" alt="" class="model-card__meta-icon shrink-0" width="16" height="16" />
          <span>{{ card.date }}</span>
        </div>
      }
    </div>
  </div>

  <div class="model-card__badge self-start text-sm font-medium" [ngClass]="getBadgeModifierClass()">
    @if ((card.badgeColor ?? 'public') === 'restricted') {
      <img src="/icons/lock-blue.svg" alt="" width="16" height="16" class="model-card__badge-icon" />
    } @else {
      <img src="/icons/globe-blue.svg" alt="" width="16" height="16" class="model-card__badge-icon" />
    }
    <span class="model-card__badge-label">{{ card.badge || 'Public' }}</span>
  </div>

  <div class="model-card__divider" role="separator" aria-hidden="true"></div>

  <footer class="model-card__footer flex flex-wrap items-center gap-x-3 gap-y-2 justify-between">
    <div class="model-card__metrics flex flex-wrap items-center gap-x-4 gap-y-2 text-sm min-w-0 flex-1">
      <span class="inline-flex items-center gap-1.5">
        <img src="/icons/thumbs-up.svg" alt="" width="14" height="14" class="shrink-0" />
        {{ formatMetric(card.metrics?.likes) }} likes
      </span>
      <span class="inline-flex items-center gap-1.5">
        <img src="/icons/eye-grey.svg" alt="" width="14" height="14" class="shrink-0" />
        {{ formatMetric(card.metrics?.views) }} views
      </span>
    </div>
    <button
      type="button"
      class="model-card__arrow shrink-0"
      aria-label="View model details"
      (click)="onArrowClick($event)"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 12H19M19 12L12 5M19 12L12 19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </footer>
</article>
